
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { promptBox } from '../PromptBox';
import { Dropdown, Tooltip as NCTooltip, HotKeys as NCHotKeys, Button as NCButton, Checkbox as NCCheckbox, Switch, Input as NCFormControl, getFunctionDisplay } from '@platform/base';
import { getAllSearchDataEve, clearAllValueEve } from './methods';
import {
    initDefaultSnapshot,
    templateFilter,
    initSimpleSnap,
    planExtend,
    getTimezoneOffset,
    getFunctionValueFromViewModal,
    _clone,
    allItemsFillComplete,
    setOperationOptionsMultiLang,
    beSureBtnClick,
    setDefaultScheme,
    beSureBtnClick_Del,
    isDateFunction,
    tree2Array,
    createOperation,
} from './_methods';
import { getSysFieldid, isFunction, isEmpty, PubSub, setGlobalStorage, getWeekStartDay, serverTimeToLocal, formatDatetime, moment } from '@platform/api';
import { templateEngine } from './templateEngine';
// 外层方案
import Item from './item';

// 查询区每一项
import SearchItem from './searchItem';

// 查询区渲染完成发布订阅标识
const BEFORECOMPLETE = 'beforeAreaChangeComplete';
const COMPLETE = 'areaChangeComplete';
const INITNUM = 6;

export default class SearchSimCom extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showLable: props.showLable, //是否显示名称
            showFlag: false, //控制是否显示修改方案名称的输入框
            checked: false,
            showPlanItem: false,
            showSearchNameTip: false,
            focusItem: '',
        };
    }

    componentDidMount() {
        const thisDom = ReactDOM.findDOMNode(this);
        this.searchNameDOM = thisDom && thisDom.querySelector('.search-name-wrapper');
        document.addEventListener('click', this.onMousedownEvent);
    }
    onMousedownEvent = e => {
        let showPlanItem = false;
        if (this.searchNameDOM) {
            let po = this.searchNameDOM.getBoundingClientRect();
            let { height } = po;
            if (height && e.target.className.includes('icon-not-visible')) {
                showPlanItem = true;
            }
        }
        if (this.searchNameDOM?.contains(e.target)) {
            showPlanItem = this.state.showPlanItem;
        }
        if (showPlanItem === this.state.showPlanItem) return;
        this.setState({ showPlanItem });
    }
    onChangePlanVisible = () => {
        this.setState({ showPlanItem: !this.state.showPlanItem });
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.onMousedownEvent);
    }
    componentDidUpdate() {
        const thisDom = ReactDOM.findDOMNode(this);
        this.searchNameDOM = thisDom && thisDom.querySelector('.search-name-wrapper');
    }
    render() {
        return NCCreateSearch.call(this, this.props);
    }

}

function NCCreateSearch(
    {
        moduleId,
        oid,
        meta,
        clickSearchBtn, // 查询按钮点击事件回调，只返回公共查询条件，不包含自定义查询条件；如果有自定义查询条件，需要业务组在clickPlanEve方法中接收查询方案信息，并保存到业务组的state中，然后在 clickSearchBtn方法中自行合并公共条件和自定义条件。
        searchBtnName = '',
        onAfterEvent, // 编辑后事件
        showSearchBtn = true, // 是否显示查询按钮 ,默认显示
        showAdvBtn = true, // 是否显示高级查询按钮和查询方案按钮 ,默认显示
        showClearBtn = true, // 是否显示清空按钮
        replaceAdvBtnEve, // 业务组替换高级面板 (fun)
        saveSearchPlan, // 保存查询方案确定按钮事件 ，用于业务组返回自定义的查询条件
        clickPlanEve, // 点击高级面板中的查询方案事件 ,用于业务组为自定义查询区赋值
        clickAdvBtnEve, //单击高级之后的回调方法
        hideBtnArea = false, // 隐藏查询按钮区域，默认false
        advSearchClearEve, // 高级查询面板中的清空按钮 点击事件回调，用于业务组清除自定义查询条件值
        onlyShowSuperBtn = false, // 只显示高级按钮
        showFoldBtn = true,
        superBtnFieldid = 'replaceSuper',
        replaceSuperBtn = '', // 只显示高级按钮时替换高级按钮
        onOperateTypeChange, // 操作符改变时的回调
        onlyShowAdvArea = false, //在查询区只显示 高级查询部分
        onlyShowModal = false, //在查询区只显示模态框
        statusChangeEvent, //状态切换
        context = {},
        renderItem = {},
        setInitValueEvent,
        onlyShowPlan = false, // 只显示方案列表和高级查询
        currentSearch = true,
        fieldid,
        opneBtnClick, //点击展开收起的回调
        onlyShowSuperCondition = false,
        showAdvSearchPlanBtn, // 是否显示保存另存方案按钮
        showAddSearchPlan,
        hiddenFunList,
        hideSearchPlan,
        modalCloseEve,
        clickShowLableEve,
        showSearchLable,
        searchAdvBtnClick,
    } = {},
) {
    let searchInfo = this.props.searchInfo;
    let multiLang = this.props.multiLang;
    let LangData = this.props.LangData;
    let setStateEve = this.props.setStateEve;
    //删除方案时调用
    this.props._this.state.chooseSearchPlan = item => { chooseSearchPlan(item); };
    //点击查询按钮事件
    const clickSearch = () => {
        setTimeout(() => {
            let type = 'simple';

            let snapshot = searchInfo.snapshotMap[searchInfo.status];
            let data = getAllSearchDataEve(searchInfo, snapshot, context, true);
            if (data) {
                let template = templateFilter(searchInfo.itemsMap, snapshot);

                let finalData = {
                    queryAreaCode: moduleId,
                    oid,
                    querytype: 'tree',
                    querycondition: data,
                    template,
                    nctz: getTimezoneOffset(),
                };

                if (clickSearchBtn && typeof clickSearchBtn == 'function') {
                    clickSearchBtn({ ...this.props._this._this, ...this.props._this._this.props }, data, type, data && finalData);
                }
            }
        }, 0);
    };

    //重置按钮事件
    const resetEvent = () => {
        let oldvalue = _clone(searchInfo.snapshotMap[searchInfo.status]);
        let snapshot = searchInfo.snapshotMap[searchInfo.status];
        clearAllValueEve.call(this.props._this, snapshot);
        this.state.searchInfo = searchInfo;
        if (advSearchClearEve && typeof advSearchClearEve == 'function') {
            advSearchClearEve(oldvalue);
        }
        setStateEve();
    };

    //显示lable回调
    const onShowNameChange = () => {
        this.setState({ showLable: !this.state.showLable });
        setGlobalStorage('localStorage', "showLable", !this.state.showLable);
        clickShowLableEve && clickShowLableEve();
        PubSub.publishSync(BEFORECOMPLETE, true);
        setStateEve(() => {
            // 发布通知表格更新高度
            this.props._this._this.infoExchangeController.publishSync('heightChange', { area: 'searchArea' });
        });
    };

    const onHasFocus = attrcode => {
        this.setState({ focusItem: attrcode });
    };

    /* 新增方案按钮 */
    const addSearchPlanClick = () => {
        if (searchInfo.status !== 'simple') return;
        this.props.modal.show('outAddSearchPlan@' + this.props.moduleId);
    };

    const searchPlanNameChange = value => {
        searchInfo.searchPlanName = value;
        setStateEve();
    };

    /* 修改方案模态框 */
    const modalContent = (status, falg, currentPlan, searchPlanName, scope) => {
        return (
            <div className="plan-content">
                <span className="label">{multiLang['page-search-0012'] + ' '}</span>
                <span className="content">
                    <NCHotKeys
                        keyMap={{
                            high: [
                                'enter',
                            ],
                        }}
                        handlers={{ high: e => beSureBtnClick.call(this.props._this, status, falg, currentPlan, searchPlanName, this.state.checked, scope, e) }}
                    >
                        <NCFormControl
                            id="NC_searchPlanOutInput"
                            autoFocus
                            className="searchPlanModal"
                            value={searchPlanName}
                            onChange={searchPlanNameChange}
                            maxlength={100}
                        />
                    </NCHotKeys>
                </span>
                <div className="setdefault" onClick={() => {
                    this.setState({ checked: !this.state.checked });
                }}>
                    <NCCheckbox checked={this.state.checked} onClick={() => {
                        this.setState({ checked: !this.state.checked });
                    }} />
                    <span className="default-lable">{multiLang['page-search-0099']}</span>
                </div>

            </div>
        );
    };

    const onInputFocus = () => {
        document.getElementById('NC_searchPlanOutInput').focus();
    };

    //生成查询、清空、高级 ,展开收起按钮
    const createButton = hasFold => {
        let foldClass = hasFold ? ' search-component-fold' : '';
        let currentPlan = searchInfo.currentPlan;
        return (
            <div className={'search-component-rowArea' + foldClass}>
                {/**查询按钮，当展开的时候显示，收起时不显示 */}
                {!hasFold && !onlyShowSuperBtn &&
                    showSearchBtn && (
                        <NCTooltip
                            delayShow={800}
                            inverse
                            delayHide={1}
                            overlay={<div>{typeof searchBtnName == 'string' ? searchBtnName : `${multiLang['page-search-0001']}(Enter)`}</div>}
                            placement="top"
                        >
                            <span
                                fieldid={getSysFieldid('search_btn')}
                                className={
                                    showAdvBtn ? (
                                        'search-component-searchBtn'
                                    ) : (
                                        'search-component-searchBtn hide-adv-btn'
                                    )
                                }
                                onClick={clickSearch.bind(this)}
                            >
                                {searchBtnName}
                            </span>
                        </NCTooltip>
                    )}
                {/** 高级按钮 只有在不需要高级功能的情况下不显示*/}
                {!onlyShowSuperBtn &&
                    showAdvBtn && (
                        <NCTooltip
                            delayShow={800}
                            inverse
                            delayHide={1}
                            overlay={<div style={{ padding: '0' }}>{`${multiLang['page-search-0003']}(F3)`}</div>}
                            placement="top"
                        >
                            <span
                                className="superBtn"
                                onClick={() => {
                                    searchAdvBtnClick(searchInfo);
                                }}
                            >
                                <i className="iconfont icon-gaojichaxun" />
                            </span>
                        </NCTooltip>
                    )
                }
                {/**更多按钮图标, 当展开的时候需要，收起不需要 */}
                {!hasFold && !onlyShowSuperBtn && (showAdvBtn || showClearBtn || showSearchLable) && (<Dropdown
                    trigger={['hover']}
                    placement="bottomLeft"
                    overlay={(
                        <ul className="menu_items first_level">
                            {showAdvBtn && showAdvSearchPlanBtn && !currentPlan.isprepared && <li key="1" onClick={beSureBtnClick.bind(this.props._this, 'save', true, searchInfo.currentPlan, searchInfo.currentPlan.name, false, this)}><span>{multiLang["page-search-0008"]}</span><span>Ctrl+S</span></li>}
                            {showAdvBtn && showAddSearchPlan && showAdvSearchPlanBtn && <li key="2" onClick={addSearchPlanClick.bind(this)}><span>{multiLang["page-search-0081"]}</span><span>Ctrl+Shift+S</span></li>}
                            {showClearBtn && <li key="3" fieldid={getSysFieldid('searchClear_btn')} onClick={resetEvent}><span>{multiLang['page-search-0002']}</span><span>Alt+Del</span></li>}
                            {showSearchLable && <li key="4" onClick={onShowNameChange}><span>{multiLang['page-search-0096']}</span> <span><Switch checked={this.state.showLable}></Switch></span></li>}
                        </ul>)}
                >
                    <span className="moreBtn">
                        <i className="iconfont icon-gengduo" />
                    </span>
                </Dropdown >)
                }
                {/** 展开收起图标，当大于一行的时候显示*/}
                {!onlyShowSuperBtn && showFoldBtn &&
                    < NCTooltip
                        delayShow={800}
                        inverse
                        delayHide={1}
                        overlay={<span>{searchInfo.showSearchItems ? multiLang['page-search-0087'] : multiLang['page-search-0088']}</span>}
                        placement="top"
                    >
                        {<span className="search-open-icon"
                            onClick={() => {
                                searchInfo.showSearchItems = !searchInfo.showSearchItems;
                                PubSub.publishSync(BEFORECOMPLETE, true);
                                setStateEve(() => {
                                    // 发布通知表格更新高度
                                    this.props._this._this.infoExchangeController.publishSync('heightChange', { area: 'searchArea' });
                                    opneBtnClick && opneBtnClick();
                                });
                            }}
                        ><i style={searchInfo.showSearchItems ? { transform: "rotate(180deg)", display: 'inline-block' } : {}} className="iconfont icon-shouqi4" /></span>}
                    </NCTooltip>
                }
                {/** 只显示高级按钮*/}
                {
                    onlyShowSuperBtn && (
                        // <NCTooltip
                        //     delayShow={800}
                        //     inverse
                        //     delayHide={1}
                        //     overlay={<div>{replaceSuperBtn || multiLang['page-search-0003']}</div>}
                        //     placement="top"
                        // >
                        <NCButton
                            style={{ maxWidth: onlyShowSuperBtn ? 'initial' : '29%' }}
                            // className="superBtn"
                            colors="primary"
                            onClick={searchAdvBtnClick.bind(this, searchInfo)}
                            fieldid={getSysFieldid(superBtnFieldid)}
                        >
                            {replaceSuperBtn || multiLang['page-search-0003']}
                        </NCButton>
                        // </NCTooltip>
                    )
                }
            </div >
        );
    };

    // 生成查询条件
    const createDom = (snapshotItem, flag = false, buttonFlag, zindex, index) => {
        let showLableFlag = showSearchLable && this.state.showLable;
        let classLable = showLableFlag ? ' search-button-lable' : '';
        if (buttonFlag && zindex === 0) {
            return (
                (!searchInfo.showSearchItems) && (
                    <div className={"search-button" + classLable}>
                        {hideBtnArea ? null : createButton()}
                    </div>
                )
            );
        }
        let templetItem = searchInfo.itemsMap[snapshotItem.attrcode];
        if (!templetItem) {
            //toast({ content: '查询方案损坏！', color: 'warning' });
            return null;
        } else {
            let dom = new templateEngine({
                moduleId,
                isAdvDom: false,
                searchInfo,
                snapshotItem,
                onAfterEvent,
                setStateEve,
                renderItem,
                context: this.props.context,
                multiLang,
                LangData,
                clickSearch,
                hiddenFunList,
                showLableFlag,
                showSearchLable,
                onOperateTypeChange,
                onHasFocus,
                focusAttrcode: this.state.focusItem,
            });
            return (
                <SearchItem
                    areaId={moduleId}
                    key={searchInfo.currentPlan.pk_ncc_queryscheme + snapshotItem.attrcode + zindex + index}
                    name={snapshotItem.attrcode}
                    itemtype={templetItem.itemtype}
                    fieldid={getSysFieldid(snapshotItem.attrcode)}
                    className="search-item-wrap"
                    dom={dom}
                    hotkeytag={`searchArea-${snapshotItem.attrcode}`}
                />
            );
        }
    };

    // 点击查询方案
    const chooseSearchPlan = (item, e) => {
        if (item.pk_ncc_queryscheme == searchInfo.currentPlan.pk_ncc_queryscheme) return;
        let attrcodeArr = [];
        searchInfo.status = 'simple';
        searchInfo.currentPlan = item;
        searchInfo.isDefaultPlan = item.pk_ncc_queryscheme == '001';

        initSimpleSnap(context, searchInfo, item, false);
        searchInfo.snapshotMap.simple = item.renderobj4web_snap;

        if (isFunction(clickPlanEve)) {
            clickPlanEve(item, this.props._this._this);
        }
        isFunction(setInitValueEvent) && setInitValueEvent('simple');
        isFunction(statusChangeEvent) && statusChangeEvent('simple');
        //暂时去掉保存选择查询方案时 查询的方法 xuyang
        if (isFunction(clickSearchBtn) && allItemsFillComplete(searchInfo.snapshotMap[searchInfo.status], searchInfo, context)) {
            clickSearch();
        }
        setStateEve();
        //选择查询方案的时候触发变化方法
        this.props._this._this.infoExchangeController.publish('heightChange', { area: 'searchArea' });
        // 发布通知表格更新高度
        PubSub.publish(COMPLETE, true);
        // 切换方案时  clearWraning
        PubSub.publish('clearWarning', attrcodeArr);
    };

    /* 删除查询方案 */
    const delSearchPlan = pk_ncc_queryscheme => {
        promptBox({
            color: 'warning',
            hotKeyboard: true,
            title: multiLang['page-search-0031'],
            content: <div>{multiLang['page-search-0015']}</div>, // 提示内容,非必输
            beSureBtnName: multiLang['page-search-0009'], // 确定按钮名称, 默认为"确定",非必输
            cancelBtnName: multiLang['page-search-0010'],
            beSureBtnClick: beSureBtnClick_Del.bind(this.props._this, true, pk_ncc_queryscheme),
        });
    };
    // 创建查询方案
    const createSearchPlan = () => {
        // console.log(searchInfo)
        let searchPlan = searchInfo.searchPlanCache;
        let dom = null;
        if (!searchPlan || !searchPlan.length) {
            dom = (
                <a>
                    <p className="searchPlanList" fiedlid={`${multiLang['page-search-0019']}_sub-btn`}>
                        <span className="searchPlanName">{multiLang['page-search-0019']}</span>
                    </p>
                    <p className="searchPlanList" fiedlid={`${multiLang['page-search-0020']}_sub-btn`}>
                        <span className="addSearchPlanHref" onClick={searchAdvBtnClick.bind(this, searchInfo)}>
                            {multiLang['page-search-0020']}
                        </span>
                    </p>
                </a>
            );
        } else {
            // 外层方案查询 (已提出,可放置到内部)
            dom = searchPlan.map((key, index) => (
                <p key={key.pk_ncc_queryscheme} className="searchPlanList" fielid={`${key.name}_sub-btn`}>
                    <Item
                        item={key}
                        value={key.name}
                        searchInfo={searchInfo}
                        meta={meta}
                        chooseSearchPlan={chooseSearchPlan.bind(this, key)}
                        searchAdvBtnClick={searchAdvBtnClick.bind(this, searchInfo, '2', key.name)}
                        // editSearchPlan={editSearchPlan.bind(this)}
                        delSearchPlan={delSearchPlan.bind(this, key.pk_ncc_queryscheme)}
                        beSureBtnClick={searchPlanName => { beSureBtnClick.call(this.props._this, 'edit', true, key, searchPlanName, false, this); }}
                        showFlag={this.state.showFlag}
                        setDefaultScheme={pk_ncc_queryscheme => { setDefaultScheme.call(this.props._this, true, key, pk_ncc_queryscheme, oid); }}
                        multiLang={multiLang}

                    />
                </p>
            ));
        }
        return (
            <div
                className="searchPlanBox"
            >
                {dom}
            </div>
        );
    };

    const getFuntionValue = (item, multiLang) => {
        let temItem = searchInfo.itemsMap[item.attrcode];
        const functionList = {
            '#day(-1)#': multiLang['page-search-0060'],
            '#day(0)#': multiLang['page-search-0061'],
            '#day(1)#': multiLang['page-search-0062'],
            '#month(-1)#': multiLang['page-search-0063'],
            '#month(0)#': multiLang['page-search-0064'],
            '#month(1)#': multiLang['page-search-0065'],
            '#week(-1)#': multiLang['page-search-0066'],
            '#week(0)#': multiLang['page-search-0067'],
            '#week(1)#': multiLang['page-search-0068'],
            '#quarter(-1)#': multiLang['page-search-0069'],
            '#quarter(0)#': multiLang['page-search-0070'],
            '#quarter(1)#': multiLang['page-search-0071'],
            '#year(-1)#': multiLang['page-search-0072'],
            '#year(0)#': multiLang['page-search-0073'],
            '#year(1)#': multiLang['page-search-0074'],
            '#lastDayOfMonth#': multiLang['page-search-0075'],
            '#lastDayOfWeek#': multiLang['page-search-0076'],
            '#finalDayOfLastMonth#': multiLang['page-search-0077'],
            '#past#': multiLang['page-search-0100'], //至过去
            '#future#': multiLang['page-search-0101'], //至未来
        };
        let timeItemList = [
            'datepicker',
            'datetimepicker',
            'rangepicker',
            'NCTZDatePickerStart',
            'NCTZDatePickerEnd',
            'NCTZDatePickClientTime',
            'NCTZDatePickClientHourTime',
            'NCTZDatePickerRangeDay',
            'datePickerNoTimeZone',
        ];
        let valArr = [];
        let resultArr = [];
        let val = item.initialvalue.value;
        let operationSign = item.operationSign;
        let itemtype = item.itemtype;
        let isconverttimezones = item.isconverttimezones;
        let dateFlag = itemtype === 'datetimepicker' ? 'datetime' : 'date';
        let range = operationSign === 'between' ? true : false;
        let singleValue;
        if (itemtype === 'NCTZDatePickerEnd') {
            singleValue = 'end';
        } else if (itemtype === 'NCTZDatePickerStart') {
            singleValue = 'start';
        }
        if (val) {
            if (typeof val === 'string' && range) {
                valArr = val.split(',');
            } else if (Array.isArray(val)) {
                valArr = val;
            } else {
                valArr = [val];
            }
        }
        for (var i = 0; i < valArr.length; i++) {
            if (valArr[i] && timeItemList.includes(itemtype)) {
                if (valArr[i].indexOf('#') !== -1) {
                    let timeValue = getFunctionDisplay(valArr[i], { ...temItem, range, multiLang, singleValue })
                    if (range) {
                        timeValue[i] && resultArr.push(timeValue[i]);
                    } else {
                        timeValue && resultArr.push(timeValue);
                    }
                } else {
                    resultArr.push(formatDatetime(serverTimeToLocal(moment(valArr[i]), isconverttimezones), dateFlag));
                }
            }
        }
        if (resultArr.length) {
            return resultArr.join(',');
        }
        return item.initialvalue.display;
    };

    // count search conditions --- add by wanglongx
    const countQueryConditions = (item, multiLang) => {
        let itemtype = searchInfo.itemsMap[item.attrcode].itemtype;
        if (itemtype === 'checkbox') itemtype = 'select';
        switch (itemtype) {
            case 'refer':
                return item.initialvalue.display;
            case 'select':
                let options = searchInfo.itemsMap[item.attrcode].options;
                let option = options.find(i => i.value == item.initialvalue.value);
                if (option) {
                    return option.display;
                }
                if (Array.isArray(item.initialvalue.display)) {
                    return item.initialvalue.display.join(',');
                } else {
                    return item.initialvalue.display;
                }
            case 'datepicker':
                return getFuntionValue(item, multiLang);
            case 'NCTZDatePickerEnd':

                return getFuntionValue(item, multiLang);
            case 'NCTZDatePickerStart':
                return getFuntionValue(item, multiLang);
            case 'radio':
                return item.initialvalue.display;
            // case 'checkbox':
            //     return <NCCheckbox checked={!(item.initialvalue.value === 'N' || item.initialvalue.value === false)} disabled />;
            case 'checkbox_switch':
                return <NCCheckbox checked={!(item.initialvalue.value === 'N' || item.initialvalue.value === false)} disabled />;
            case 'rangepicker':
                return getFuntionValue(item, multiLang);
            case 'datetimepicker':
                return getFuntionValue(item, multiLang);
            default:
                if (Array.isArray(item.initialvalue.value)) {
                    return item.initialvalue.value.join(',');
                } else {
                    return item.initialvalue.value;
                }

        }
    };

    // add by wanglongx 

    const createTitle = () => {

        let res = null;

        res = <span>{multiLang['page-search-0025']}: <span className="search-conditions-number">({tree2Array(searchInfo.snapshotMap['simple']).filter(item => checkIsVisible(item)).length})</span></span>;
        return res;
    };

    // 防抖——触发高频事件后 n 秒后函数只会执行一次，如果n毫秒内高频事件再次被触发，则重新计算时间；
    const debounce = (fn, interval) => {
        let timeout = null; // 创建一个标记用来存放定时器的返回值
        return function () {
            if (timeout) {
                clearTimeout(timeout); // 每当事件触发的时候把前一个 setTimeout clear 掉
            }
            timeout = setTimeout(() => { // 然后又创建一个新的 setTimeout, 这样就能保证interval间隔时间触发的话，就不会执行 fn 函数
                fn.apply(this, arguments);
            }, interval);
        };
    };

    const searchEnter = () => {
        document.activeElement.blur();
        clickSearch();
    };

    //查询区目前展示方式 ：1、只显示高级按钮 ；2、都显示
    const createSearchDom = () => {
        let { snapshotMap, itemsMap, showAdvModal } = searchInfo;
        let showLableFlag = showSearchLable && this.state.showLable;
        if (onlyShowSuperBtn) {
            return <div className="lightapp-component-search" style={{ marginTop: '0px' }}>{hideBtnArea ? null : createButton()}</div>;
        } else {
            // 每五个一行 第一行后面放 button
            let allItem = [];
            let temp = [];
            let snapshot_list = tree2Array(snapshotMap['simple']);
            let snapshot = [];
            snapshot_list.forEach(element => {
                if (element.visible !== false) {
                    let operationOptions = createOperation(itemsMap[element.attrcode].queryOperateType);
                    if (operationOptions.length > 0) {
                        if (!operationOptions.some(i => element.operationSign === i.value)) {
                            element.operationSign = (operationOptions[0] && operationOptions[0].value) || element.operationSign || '=';
                            // element.initialvalue = { display: '', value: '' };
                        }
                        element.operationOptions = operationOptions;
                    }
                    snapshot.push(element);
                }
            });
            // snapshot = snapshot_list.filter(item => item.visible !== false);

            snapshot.map((item, index) => {
                let val = itemsMap[item.attrcode];
                if (val) {
                    temp.push(item);
                    if (temp.length === INITNUM) {
                        allItem.push([...temp]);
                        temp = [];
                    }
                }
            });
            if (temp.length > 0) {
                allItem.push(temp);
            }

            let classLable = '';
            if (showLableFlag && (!searchInfo.showSearchItems)) {
                classLable = ' search-top-lable';
            }
            return (
                // 1909 search add by wanglongx
                // 内部快捷键 enter
                <NCHotKeys
                    className="lightapp-component-search"
                    keyMap={{
                        query: [
                            'enter',
                        ],
                        delete: ['Alt+Del'],
                    }}
                    handlers={{
                        delete: () => {
                            // blur 触发保存 强制让 body 获取焦点
                            document.body.focus();
                            resetEvent.call(this);
                        },
                        query: debounce.call(this, searchEnter, 300),
                    }}
                    style={{ marginTop: showLableFlag && !searchInfo.showSearchItems ? '0px' : '4px', display: "flex", marginBottom: searchInfo.showSearchItems || showLableFlag ? '4px' : '0px' }}
                    attach={false}
                >
                    {/* 注册全局 F3 */}
                    <NCHotKeys
                        keyMap={{
                            high: ['f3'],
                            save: ['ctrl+s'],
                            add: ['ctrl+shift+s'],
                        }}
                        handlers={{
                            high: () => {
                                // f3 部分情况下禁用.
                                currentSearch && showAdvBtn && !showAdvModal && searchAdvBtnClick(searchInfo);
                            },
                            save: e => { if (searchInfo.status !== 'simple' || searchInfo.currentPlan.isMyPlan) return; currentSearch && beSureBtnClick.call(this.props._this, 'save', true, searchInfo.currentPlan, searchInfo.currentPlan.name, false, this); },
                            add: currentSearch && addSearchPlanClick,
                        }}
                        display="inline"
                        attach={document.body}
                        focused={true}
                    />
                    {/** 另存新方案弹窗,将该内容提到最外层组件 */}
                    {!isEmpty(multiLang) && this.props.modal.createModal('outAddSearchPlan@' + this.props.moduleId, {
                        title: multiLang['page-search-0081'],
                        content: modalContent.call(this.props._this, 'add', true, searchInfo.currentPlan, searchInfo.searchPlanName, this),
                        // size: 'sm',
                        minHeight: 170,
                        minWidth: 400,
                        width: 400,
                        backdrop: 'static',
                        cancelBtnClick: () => { this.setState({ checked: false }) },
                        closeModalEve: () => { this.setState({ checked: false }) },
                        beSureBtnClick: () => beSureBtnClick.call(this.props._this, 'add', true, searchInfo.currentPlan, searchInfo.searchPlanName, this.state.checked, this),
                        leftBtnName: multiLang['page-search-0009'],
                        rightBtnName: multiLang['page-search-0010'],
                        zIndex: 310,
                        onEntered: onInputFocus,
                        className: 'search-modal',

                    })}
                    {/**有高级功能的情况需要查询方案列表 */}
                    {showAdvBtn && !hideSearchPlan && (
                        <div className={"search-top" + classLable}>
                            <div className="search-edit">
                                <Dropdown
                                    placement="bottomLeft"
                                    visible={this.state.showPlanItem}
                                    overlay={(
                                        <div className="query_condo">
                                            <ul className="query_content">
                                                {createSearchPlan.call(this)}
                                            </ul>
                                            <div
                                                className="create_new"
                                                fieldid={getSysFieldid('create_new_btn')}
                                                onClick={e => {
                                                    let classname = e.target.className;
                                                    if (classname && classname.includes('icon-not-visible')) {
                                                        return;
                                                    }
                                                    searchAdvBtnClick(searchInfo);
                                                }}
                                            >
                                                <sapn className="new_content">{` + ${multiLang['page-search-0080']}`}</sapn>
                                                <NCTooltip
                                                    delayShow={800}
                                                    delayHide={1}
                                                    inverse
                                                    overlay={multiLang['page-search-0098']}
                                                    placement="top">
                                                    <i className="iconfont icon-not-visible icon-bangzhutishi" />
                                                </NCTooltip>

                                            </div>
                                        </div>
                                    )}

                                    onVisibleChange={a => {
                                        if (a) {
                                            this.setState({ showFlag: true });
                                        }
                                    }}
                                    fieldid="search-plan"
                                >

                                    <div className="search-name-wrapper"
                                        fieldid={getSysFieldid('search-plan_btn')}
                                        onClick={this.onChangePlanVisible}
                                    >
                                        <NCTooltip
                                            delayShow={800}
                                            delayHide={1}
                                            inverse
                                            overlay={this.state.showSearchNameTip ? ((searchInfo.currentPlan && searchInfo.currentPlan.name) || searchInfo.defaultPlan.name) : null}
                                            placement="top">
                                            <span className="search-plan-name"
                                                onMouseEnter={e => {
                                                    e.stopPropagation();
                                                    if (e.target && e.target.scrollWidth > e.target.clientWidth) {
                                                        this.setState({ showSearchNameTip: true });
                                                    }

                                                }}
                                                onMouseLeave={e => {
                                                    e.stopPropagation();
                                                    if (!this.state.showSearchNameTip) return;
                                                    this.setState({ showSearchNameTip: false });
                                                }}
                                            >{(searchInfo.currentPlan && searchInfo.currentPlan.name) || searchInfo.defaultPlan.name}</span>
                                        </NCTooltip>
                                        <i className="iconfont icon-hangcaozuoxiala1" />

                                    </div>

                                </Dropdown>
                            </div>
                            {/* {(!onlyShowPlan && !onlyShowSuperBtn && showAdvBtn) && (
                                 <div
                                     className="search-open"
                                     onClick={() => {
                                         searchInfo.showSearchItems = !searchInfo.showSearchItems;
                                         PubSub.publishSync(BEFORECOMPLETE, true);
                                         setStateEve(() => {
                                             this.props._this._this.infoExchangeController.publishSync('heightChange', { area: 'searchArea' });
                                             // 发布通知表格更新高度
                                             opneBtnClick && opneBtnClick();
                                             // PubSub.publish(COMPLETE, true);
                                         });
                                     }}
                                 >
                                     {searchInfo.showSearchItems ? <span className="search-open-icon" ><i className="label">{multiLang['page-search-0087']}</i><i className="iconfont icon-chaxunmoren" /></span> : <span className="search-open-icon" ><i className="label">{multiLang['page-search-0088']}</i><i className="down iconfont icon-chaxunmoren" /></span>}
                                 </div>
                             )} */}
                        </div>
                    )
                    }
                    {/**当少于一行的时候收起展示的还是展开的样子 */}
                    {
                        searchInfo.showSearchItems && (
                            <Dropdown
                                trigger={[
                                    'hover',
                                ]}
                                overlayClassName="search-dropdown"
                                minOverlayWidthMatchTrigger={false}
                                delayShow={0.8}
                                placement="bottomLeft"
                                overlay={
                                    snapshot_list.filter(item => item.initialvalue.value).length && (
                                        <div className="search-condition">
                                            {snapshot_list.map(item => {
                                                if (checkIsVisible(item)) {
                                                    return (
                                                        <p className="search-condition-item">
                                                            <span className="item-title">{`${searchInfo.itemsMap[item.attrcode].label}: `}</span>
                                                            <span className="item-content">{countQueryConditions(item, multiLang)}</span>
                                                        </p>
                                                    );
                                                }
                                            })}
                                        </div>
                                    )
                                }
                            >
                                <div
                                    className="search-conditions-value"
                                    onClick={() => {
                                        searchInfo.showSearchItems = false;
                                        setStateEve();
                                    }}
                                >
                                    <span>
                                        {searchInfo.showSearchItems && createTitle()}&nbsp;&nbsp;
                                        {snapshot_list.map(item => {
                                            if (checkIsVisible(item)) {

                                                return searchInfo.itemsMap[item.attrcode].label + ';';
                                            }
                                        })}
                                    </span>
                                </div >
                            </Dropdown>
                        )
                    }
                    {/**当收起的时候需要高级和展开两个按钮 */}
                    {searchInfo.showSearchItems && createButton(true)}
                    {/** 展开的时候显示的内容，主要包括查询项，查询、高级、更多、展开收起按钮*/}
                    {
                        !onlyShowPlan && (!searchInfo.showSearchItems) && (
                            <div className="item-contant">
                                {allItem.map((item, zindex) => {
                                    if (zindex === 0) item.push('button');
                                    return (
                                        <div className="item-rows" style={{ marginTop: zindex && !showLableFlag ? '8px' : '0px' }}>
                                            {item.map((data, index) => createDom(data, zindex > 0, index === item.length - 1, zindex, index))}
                                        </div>
                                    );
                                })}
                            </div>
                        )
                    }
                </NCHotKeys >
            );
        }
    };
    function isTrueEmpty(data) {
        if (isEmpty(data)) return true;
        else if (Array.isArray(data)) {
            return data.filter(item => item).length === 0;
        }
    }
    function checkIsVisible(item) {
        if (item.operationSign == 'is null' || item.operationSign == 'is not null') {
            return true;
        } else if (!isTrueEmpty(item.initialvalue.value) && item.itemtype != 'refer') {
            return true;
        } else if (!isEmpty(item.initialvalue.display) && item.itemtype == 'refer') {
            return true;
        } else {
            return false;
        }

    }

    return isEmpty(multiLang) ? null : createSearchDom();
}
